import { Outlet } from 'react-router-dom'
import { FooterLayout } from '../FooterLayout'
import { Col, Layout, Row, theme } from 'antd'

const { Content } = Layout

const AuthLayout: React.FC = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken()

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout className="site-layout">
        <Content
          style={{
            margin: '0',
            backgroundImage: "url('assets/login_background.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <Row
            justify="center"
            style={{
              padding: 0,
              margin: 0,
              height: '100vh',
            }}
          >
            <Col
              xxl={8}
              xl={10}
              lg={12}
              md={14}
              xs={24}
              style={{
                justifyContent: 'center',
                alignSelf: 'center',
                textAlign: 'center',
                background: '#f8f8f2',
              }}
            >
              <Outlet />
            </Col>
          </Row>
        </Content>
        <FooterLayout />
      </Layout>
    </Layout>
  )
}

export default AuthLayout
